import { restoreText } from "../../Careers/careersFormat";
import type { CustomPrintoutDetail, CustomPrintoutVersionSummary } from "./customPrintoutTypes";

/*
 * `axiosInstance` turns any response string that is exactly an ISO date into a Luxon `DateTime`. A request is typed
 * by a head nurse and a summary is written by Annie, so either can be "2026-01-05" — and an object rendered as text
 * throws. Printout names can't take that shape (`validatePresetName`); these fields are put back to text here.
 */

/** A printout version as the server sent it, its typed and written text back to strings. */
export const restoreDetailText = (detail: CustomPrintoutDetail): CustomPrintoutDetail => ({
	...detail,
	summary: restoreText(detail.summary),
	conversation: detail.conversation.map((turn) => ({ ...turn, request: restoreText(turn.request), summary: restoreText(turn.summary) })),
});

/** A version-history row with its summary back to a string. */
export const restoreVersionRowText = (row: CustomPrintoutVersionSummary): CustomPrintoutVersionSummary => ({ ...row, summary: restoreText(row.summary) });
